import { Outlet } from 'react-router-dom';
import ExtensionRoute from '../../components/ExtensionRoute';

export default function OperationalPurchasesRoutes() {
  return (
    <ExtensionRoute extensionId="operational-purchases">
      <Outlet />
    </ExtensionRoute>
  );
}
